<template>
  <v-menu
    class="updatable-team__menu"
    v-model="menu"
    :close-on-click="false"
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <span class="updatable-team__label" v-bind="attrs" v-on="on">{{
        gig.qb_class_name
      }}</span>
    </template>

    <v-card class="updatable-team__content">
      <v-btn class="dialog-close" icon @click="close">
        <v-icon>$close</v-icon>
      </v-btn>
      <div class="updatable-team__form">
        <QbClassSelector
          v-model="localValue"
          placeholder="Team/Department"
          @input="input($event)"
          exclude-deprecated
        />
      </div>
      <v-btn
        :disabled="localValue == gig.qb_class_id || localValue === undefined"
        @click="submit"
        elevation="0"
        color="primary"
        >Update</v-btn
      >
    </v-card>
  </v-menu>
</template>

<script>
import QbClassSelector from "@/components/selects/QbClassSelector.vue";

export default {
  components: { QbClassSelector },
  props: {
    gig: Object,
  },
  data() {
    return {
      menu: false,
      localValue: this.gig.qb_class_id,
    };
  },
  methods: {
    input(event) {
      console.info("$event", event);
      this.localValue = event;
    },
    async submit() {
      try {
        const res = await this.$api.WorkAssignment.update({
          id: this.gig.id,
          qb_class_id: this.localValue,
        });
        this.menu = false;
        this.$emit("refresh");
        if (res.status == 200) {
          this.$alert("Team/Department updated successfully.");
        }
      } catch (e) {
        console.info("error", e);
        this.$alert("Something went wrong", "error");
      }
    },
    close() {
      this.menu = false;
      this.localValue = this.gig.qb_class_id;
    },
  },
};
</script>

<style scoped lang="scss">
#app.disabled-theme .updatable-team {
  display: inline-block;
  &__label {
    font-weight: bold;
    &:hover {
      text-decoration: underline;
    }
  }
  &__content {
    padding: 3em 2em 2em 1.5em;
    .v-btn {
      color: white !important;
      &.v-btn--disabled {
        background-color: rgba(0, 0, 0, 0.12) !important;
        color: rgba(0, 0, 0, 0.26) !important;
      }
    }
  }
  &__form {
    margin-bottom: 1em;
  }
}

.dialog-close {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
  color: #56565a !important;
}
</style>
